import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=c1ecc952&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"
import style0 from "./payment.vue?vue&type=style&index=0&id=c1ecc952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ecc952",
  null
  
)

export default component.exports